import { render, staticRenderFns } from "./bottomCard.vue?vue&type=template&id=49d49c22&scoped=true&"
import script from "./bottomCard.vue?vue&type=script&lang=ts&"
export * from "./bottomCard.vue?vue&type=script&lang=ts&"
import style0 from "./bottomCard.vue?vue&type=style&index=0&id=49d49c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d49c22",
  null
  
)

export default component.exports